/**
 * The seven garment floor stations, in production order. Shared so the
 * supervisor Floor (`/production/floor`) and the tablet Station Mode (`/station`) agree on
 * the same labels, icons, and descriptions instead of each hard-coding them
 * (§7 rule 17). Keys are the `wip` stage enum, so a station is directly usable
 * as a `wip.queue` / `wip.record` `stage`.
 */
import { Scissors, Shirt, Sparkles, Droplet, Flame, ShieldCheck, Package } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { wip as wipContract } from "@flint/api-contract";

export interface GarmentStation {
  key: wipContract.WipStage;
  label: string;
  desc: string;
  icon: LucideIcon;
}

export const GARMENT_STATIONS: readonly GarmentStation[] = [
  { key: "cutting", label: "Cutting", desc: "Cutting Master · fabric → size-wise pieces", icon: Scissors },
  { key: "stitching", label: "Stitching", desc: "Line Supervisor · sewing output", icon: Shirt },
  { key: "khaja", label: "Khaja / Button", desc: "Finishing · buttonhole & buttons", icon: Sparkles },
  { key: "washing", label: "Washing", desc: "Wash partner · colour / shrinkage", icon: Droplet },
  { key: "ironing", label: "Ironing", desc: "Pressing · ready for QC", icon: Flame },
  { key: "qc", label: "Quality Control", desc: "QC Inspector · pass / reject", icon: ShieldCheck },
  { key: "packing", label: "Packing", desc: "Dispatch · finished goods", icon: Package },
];

/** Lookup a station by its stage key. */
export function stationByKey(key: string): GarmentStation | undefined {
  return GARMENT_STATIONS.find((s) => s.key === key);
}
